import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './utils/store'

// 全局处理微信扫码登录回调
function handleWechatLoginCallback() {
  console.log('应用启动，检查微信扫码登录回调...');
  
  // 获取完整的URL
  const url = window.location.href;
  console.log('当前URL:', url);
  
  // 检查URL中是否包含phone参数
  if (url.includes('phone=')) {
    console.log('检测到微信扫码登录回调，提取参数...');
    
    // 尝试多种方式提取参数
    let phone = null;
    let avatar = null;
    
    // 方式1：使用正则表达式提取参数
    const phoneMatch = url.match(/phone=([^&]+)/);
    const avatarMatch = url.match(/(?:avatar|vatar)=([^&]+)/);
    
    if (phoneMatch) {
      phone = decodeURIComponent(phoneMatch[1]);
      console.log('通过正则表达式提取到phone:', phone);
    }
    
    if (avatarMatch) {
      avatar = decodeURIComponent(avatarMatch[1]);
      console.log('通过正则表达式提取到avatar:', avatar);
    }
    
    if (phone) {
      console.log('微信登录成功，存储用户信息...');
      
      // 将用户信息存储到store中
      const userInfo = {
        nickname: phone, // 这里phone实际上是用户昵称
        avatar: avatar || '',
        phone: '' // 可能需要从其他地方获取phone
      };
      
      // 直接调用setUser mutation设置用户信息
      store.mutations.setUser(userInfo);
      console.log('用户信息已存储到store中:', userInfo);
      console.log('登录状态:', store.state.isLoggedIn);
      console.log('存储的用户信息:', store.state.user);
      
      // 清除URL中的参数但不重新加载页面
      window.history.replaceState({}, document.title, '/home');
      console.log('URL参数已清除，页面保持不变');
    }
  }
}

// 应用启动时处理微信扫码登录回调
handleWechatLoginCallback();

createApp(App).use(router).mount('#app')
